<template>
  <div class="documenti-generici">
    <div class="titolo">
      {{$t('documentiGenerici.titolo')}}
    </div>    

    <el-select v-model="statoSelected" class="custom-select-el">
      <el-option
        v-for="item in stati"
        :key="item"
        :label="($t('documentiGenerici')[item])"
        :value="item">
      </el-option>
    </el-select>

    <div class="documenti">
      <!-- Documenti ITALIA -->
      <div class="documento" v-if="(statoSelected === '1')">
        <span class="doc-nome">- Informativa privacy Riva Acciaio</span>
        <a href="https://www.rivaacciaio.com/TMS/items/1132/allegati/1/RivaAcciaio_InformativaPrivacy_area_riservata_Fornitori.pdf" target="_blank">
          <icon name="riv-downloadPas" scale="1.3" class="icona pointer"></icon>
        </a>
      </div>
      <div class="documento" v-if="(statoSelected === '1')">
        <span class="doc-nome">- Informativa privacy Riva Forni Elettrici</span>
        <a href="https://www.rivagroup.com/TMS/items/1580/allegati/1/RFE_Informativa_Privacy_area_riservata_Fornitori.pdf" target="_blank">
          <icon name="riv-downloadPas" scale="1.3" class="icona pointer"></icon>
        </a>
      </div>

      <!-- Documenti FRANCIA -->
      <div class="documento" v-if="(statoSelected === '2')">
        <span class="doc-nome">- Politique de protection des données</span>
        <a href="https://www.rivaacier.com/items/1296/allegati/1/RivaAcier_ProtectionDonnees_WEB_FR.pdf" target="_blank">
          <icon name="riv-downloadPas" scale="1.3" class="icona pointer"></icon>
        </a>
      </div>
      <div class="documento" v-if="(statoSelected === '2')">
        <span class="doc-nome">- Dispositif d'alerte</span>
        <a href="https://www.rivaacier.com/items/1377/allegati/1/RivaAcier_DispositifdAalerte.pdf" target="_blank">
          <icon name="riv-downloadPas" scale="1.3" class="icona pointer"></icon>
        </a>
      </div>

      <!-- Documenti SPAGNA -->
      <div class="documento" v-if="(statoSelected === '3')">
        <span class="doc-nome">- Política de Privacidad</span>
        <a href="https://www.siderurgicasevillana.com/items/735/allegati/1/PoliticaDePrivacidad_SiderurgicaSevillana.pdf" target="_blank">
          <icon name="riv-downloadPas" scale="1.3" class="icona pointer"></icon>
        </a>
      </div>
      <div class="documento" v-if="(statoSelected === '3')">
        <span class="doc-nome">- Manual Portal Proveedores (Ofertas servicios)</span>
        <a :href="'static/docs/Acquisti/Manual proveedores.pdf'" target="_blank">
          <icon name="riv-downloadPas" scale="1.3" class="icona pointer"></icon>
        </a>
      </div>

      <!-- Documenti BELGIO -->
      <div class="documento" v-if="(statoSelected === '4')">
        <span class="doc-nome">- Politique de protection des données</span>
        <a href="https://www.thy-marcinelle.com/politique-de-protection-des-donnees/" target="_blank">
          <icon name="riv-downloadPas" scale="1.3" class="icona pointer"></icon>
        </a>
      </div>

      <!-- Documenti GERMANIA -->
      <div class="documento" v-if="(statoSelected === '5')">
        <span class="doc-nome">- Datenschutzerklärung</span>
        <a href="https://www.rivastahl.com/items/736/allegati/1/Rivastahl_Datenschutzerklarung_DE.pdf" target="_blank">
          <icon name="riv-downloadPas" scale="1.3" class="icona pointer"></icon>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DocumentiGenerici',
    props: ['language'],
    data () {
      return {
        stati: ['1', '2', '3', '4', '5'],
        statoSelected: '1'
      }
    },
    i18n: {
      messages: {
        it_IT: {
          documentiGenerici: {
            titolo: 'Documenti Generici',
            1: 'Italia',
            2: 'Francia',
            3: 'Spagna',
            4: 'Belgio',
            5: 'Germania'
          }
        },
        fr_FR: {
          documentiGenerici: {
            titolo: 'Documents Génériques',
            1: 'Italie',
            2: 'France',
            3: 'Espagne',
            4: 'Belgique',
            5: 'Allemagne'
          }
        },
        es_ES: {
          documentiGenerici: {
            titolo: 'Documentos Genéricos',
            1: 'Italia',
            2: 'Francia',
            3: 'España',
            4: 'Bélgica',
            5: 'Alemania'
          }
        },
        de_DE: {
          documentiGenerici: {
            titolo: 'Allgemeine Dokumente',
            1: 'Italien',
            2: 'Frankreich',
            3: 'Spanien',
            4: 'Belgien',
            5: 'Deutschland'
          }
        },
        en_GB: {
          documentiGenerici: {
            titolo: 'Generic Documents',
            1: 'Italy',
            2: 'France',
            3: 'Spain',
            4: 'Belgium',
            5: 'Germany'
          }
        }
      }
    },
    methods: {}
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .documenti-generici {
    height: 500px;
    padding: 15px 50px;
    background-color: #fff;
    .titolo {
      border-bottom: 1px solid @rossoRiva;
      .set-font(@color: @rossoRiva, @size: 22px, @family: 'os-semibold');
      height: 40px;
      line-height: 40px;
      text-align: right;
    }
    .el-select {
      width: 230px;
      margin-top: 30px;
      .el-input {
        .el-input__inner {
          border-radius: 0;
          border: 0;
          border-bottom: 1px solid #666;
          height: 35px !important;
          line-height: 35px  !important;
          .set-font(@size: 18px, @family: 'os-semibold', @color: #bd3090);
          letter-spacing: 4px;
        }
      }
      .el-select__caret {
        color: #666;
        font-size: 22px;
      }
    }
    .documenti {
      height: 350px;
      margin-top: 20px;
      overflow: auto;
      .documento {
        margin-top: 10px;
        .doc-nome {
          .set-font(@family: 'os-regular', @size: 18px, @color: #666);
        }
        .icona {
          color: @rossoRiva;
          float: right;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Login/DocumentiGenerici.vue